<template>
    <div v-if="!loading">
        <div v-if="jobProcessing">Export utilisateurs en cours</div>
        <div v-else>
            <b-button v-if="lastExport" type="is-dark" @click.prevent="downloadExcel">
                Télécharger le dernier export
                {{ lastExport }}
            </b-button>
            <b-button type="is-dark" @click.prevent="orderNewExport"> Lancer un nouvel export</b-button>
        </div>
    </div>
</template>

<script>
    import Download from '../../../utils/download'
    import { mapActions } from 'vuex'

    export default {
        data: () => ({
            loading: true,
            jobProcessing: false,
            lastExport: null
        }),
        created() {
            //this.loadExportInfo()
        },
        methods: {
            ...mapActions('sites', {
                exportSites: 'export',
                getLastExportInfo: 'getLastExportInfo',
                downloadExport: 'downloadExport'
            }),
            loadExportInfo() {
                this.getLastExportInfo()
                    .then(({ data }) => {
                        this.jobProcessing = data.job_processing
                        this.lastExport = data.last_export
                        if (data.job_processing == true) {
                            setTimeout(() => {
                                this.loadExportInfo()
                            }, 3000)
                        }
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            downloadExcel() {
                this.downloadExport().then(response => {
                    Download.download(response, 'liste-user.xlsx')
                })
            },
            orderNewExport() {
                this.exportSites().then(({ data }) => {
                    this.jobProcessing = data.job_processing
                    this.lastExport = data.last_export
                    if (data.job_processing == true) {
                        setTimeout(() => {
                            this.loadExportInfo()
                        }, 3000)
                    }
                })
            }
        }
    }
</script>

<style></style>
